import React, { useState, useRef, useEffect } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
// import { useDispatch, useSelector } from 'react-redux';
// import { verifyOtp } from '../../../../core/store/auth/verify-otp/thunk';
// import { useNavigate } from 'react-router-dom';
// import { createSelector } from '@reduxjs/toolkit';
// import { resetRegisterFlag } from '../../../../core/store/auth/register/thunk';
import { Link } from 'react-router-dom';

const Resetemail = () => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [timer, setTimer] = useState(30);
  const refs = useRef([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Logique de soumission à implémenter
  };

  const resendOTP = () => {
    // Logique de renvoi OTP à implémenter
  };

  return (
    <Container className="d-flex align-items-center justify-content-center min-vh-300">
      <Card className="shadow-lg" style={{ maxWidth: '450px', width: '100%', borderRadius: '15px' }}>
        <Card.Body className="p-5">
          <h2 className="text-center mb-4 fw-bold">Password Validation</h2>
          <p className="text-center text-muted mb-4">
            Please enter the 6-digit code sent to your email address.
          </p>


          <Form onSubmit={handleSubmit}>
            {/* <div className="d-flex justify-content-between mb-4">
              {otp.map((data, index) => (
                <Form.Control
                  key={index}
                  type="text"
                  maxLength="1"
                  ref={(element) => (refs.current[index] = element)}
                  value={data}
                  onChange={(e) => handleChange(e.target, index)}
                  onFocus={(e) => e.target.select()}
                  className="text-center mx-1"
                  style={{ width: '50px', height: '50px', fontSize: '1.5rem' }}
                  bsPrefix="otp-input"
                />
              ))}
            </div> */}

            {error && <Alert variant="danger" className="mb-3">{error}</Alert>}
            {success && (
              <Alert variant="success" className="mb-3">OTP validé avec succès !</Alert>
            )}
            
            <Form.Group className="mb-3">
              <Form.Control 
                type="password" 
                placeholder="Votre mot de passe" 
                required
                className="py-2"
                bsPrefix="custom-input"
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Control 
                type="password" 
                placeholder="Confirmer votre mot de passe" 
                required
                className="py-2"
                bsPrefix="custom-input"
              />
            </Form.Group>
            
            <Button 
              variant="primary" 
              type="submit" 
              className="w-100 mb-3 py-2"
              bsPrefix="custom-btn"
            >
              Valider 
            </Button>
          </Form>

          <div className="text-center mt-3">
            <Button
              variant="link"
              onClick={resendOTP}
              className="text-decoration-none mb-2"
              bsPrefix="resend-btn"
            >
              Renvoyer le code {timer > 0 && `(${timer}s)`}
            </Button>
            <div>
              <Link to="/Verifiedemail" className="btn btn-outline-secondary" bsPrefix="cancel-btn">
                Annuler
              </Link>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Resetemail;